import React, { useState, useCallback } from 'react'
import context from '@/context'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import Resx from '@/components/Resx'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { ModalBody, Label } from 'reactstrap'
import { NumericInput } from '@/components/inputs'
import { DropDownList } from '@/components/dropDownList'

const AddDataCrossingWeight = React.memo(function AddDataCrossingWeight (props) {
  const { onAction, item } = props
  const [attributeName, setAttributeName] = useState(item && item.attributeName)
  const [weight, setWeight] = useState(item && item.weight)

  const onAttributeNameChange = useCallback(({ item }) => {
    setAttributeName(item ? item.name : null)
  }, [])

  const onWeightChange = useCallback((value) => {
    if (!value || value === '') {
      setWeight(1)
    } else {
      setWeight(value)
    }
  }, [])

  const onConfirm = useCallback(() => {
    onAction({ attributeName, weight })
  }, [attributeName, weight, onAction])

  return (
    <ValidationBoundary>
      <BasicHeader title='' {...props} />
      <ModalBody>
        <Label><Resx name='DataCrossings.AttributeName' /></Label>
        <Validator name='attributeName' value={attributeName} required>
          <DropDownList
            dataSource={context.api.dataCrossingService.getAvailableAttributeNames}
            onChange={onAttributeNameChange}
            valueField='name'
            value={attributeName}
          />
        </Validator>
        <Label><Resx name='DataCrossings.Weight' /></Label>
        <Validator name='weight' value={weight} required>
          <NumericInput value={weight} onChange={onWeightChange} min={1} integerOnly />
        </Validator>
      </ModalBody>
      <ValidationState render={({ isValid }) =>
        <ConfirmFooter {...props} onAction={onConfirm} disabled={!isValid} />
      } />
    </ValidationBoundary>
  )
})

export default {
  component: AddDataCrossingWeight
}



// WEBPACK FOOTER //
// ./src/dialogs/addDataCrossingWeight.js